<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('close-outage')"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row">
        <div class="cx-dialog-info col-md-12">
          <div class="outage-notification-img">&nbsp;</div>
          <p class="outage-notification-heading" [innerHtml]="data.title"></p>
          <p class="outage-notification-content" [innerHtml]="data.content"></p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <button class="vs-primary-btn" (click)="closeModal('close-outage')">
            {{ 'landing.gotIt' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
